import ImagesPallet from "../../../../../../../../utils/ImagesPallet";

const OurStylistArizonaData = [
 {
  name: "Tyo",
  image: ImagesPallet.ReyKnoBoston,
  specialty: "Capster",
  experience: "5 years"
 },
 {
  name: "Arul",
  image: ImagesPallet.RidhoKnoBoston,
  specialty: "Hair Stylish",
  experience: "8 years"
 },
 {
  name: "Eky",
  image: ImagesPallet.WawanKnoBoston,
  specialty: "Hair Stylish",
  experience: "8 years"
 },
];

export default OurStylistArizonaData

